import { v4 as uuid } from "uuid";
import { Element } from "@/components/elements/UIElement";
import { parseElements } from "../utils";

export const GridOne: () => Record<string, Element> = () => {
  const root = uuid();
  const page = uuid();
  const container = uuid();
  const column = uuid();
  const greeting = uuid();
  const search = uuid();
  const time = uuid();
  const grid = uuid();
  const quotes = uuid();
  const profileSelector = uuid();
  const todolist = uuid();
  const time2 = uuid();
  const calendar = uuid();
  const googleEmails = uuid();
  const pomodoro = uuid();
  const app1 = uuid();
  const app2 = uuid();
  const notes = uuid();
  const weather = uuid();
  const counter = uuid();
  const guidebook = uuid();

  return parseElements([
    {
      id: root,
      name: "Root",
      parentId: null,
      childrenIds: [page],
      config: { backgroundImage: { provider: "unsplash", type: "random" } },
    },
    {
      id: page,
      name: "Row",
      parentId: root,
      childrenIds: [container],
      config: {
        width: "100vw",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      },
    },
    {
      id: container,
      name: "Row",
      parentId: page,
      childrenIds: [column],
      config: {
        alignItems: "stretch",
        justifyContent: "stretch",
        width: "1144px",
        height: "100%",
        padding: "0",
        gap: "0",
        paddingLeft: "0",
        paddingRight: "0",
        paddingTop: "0",
        paddingBottom: "0",
        position: "relative",
      },
    },
    {
      id: column,
      name: "Column",
      parentId: container,
      childrenIds: [greeting, time, search, grid, profileSelector],
      config: {
        width: "100%",
        justifyContent: "start",
        alignItems: "center",
        gap: "1rem",
        paddingTop: "2rem",
      },
    },
    {
      id: greeting,
      name: "Greeting",
      parentId: column,
      childrenIds: [],
      config: { name: "", fontSize: "30px", lineHeight: "36px" },
    },
    {
      id: search,
      name: "Search",
      parentId: column,
      childrenIds: [],
      config: {},
    },
    {
      id: time,
      name: "Time",
      parentId: column,
      childrenIds: [],
      config: {
        timeFormat: "hh:mm:ss",
        dateFormat: "dd/MM/yyyy",
        timeAlign: "center",
        dateAlign: "center",
        gap: "0",
      },
    },
    {
      id: grid,
      name: "Grid",
      parentId: column,
      childrenIds: [
        quotes,
        todolist,
        calendar,
        googleEmails,
        time2,
        pomodoro,
        app1,
        app2,
        notes,
        weather,
        counter,
      ],
      config: {},
    },
    {
      id: quotes,
      name: "Quotes",
      parentId: grid,
      childrenIds: [],
      config: { grid: [4, 1, 4, 7] },
    },
    {
      id: profileSelector,
      name: "ProfileSelector",
      parentId: column,
      childrenIds: [guidebook],
      config: { autoHide: false },
    },
    {
      id: guidebook,
      name: "Guidebook",
      parentId: profileSelector,
      childrenIds: [],
      config: { open: true },
    },
    {
      id: todolist,
      name: "TodoList",
      parentId: grid,
      childrenIds: [],
      config: {
        grid: [3, 3, 7, 0],
      },
    },
    {
      id: calendar,
      name: "Calendar",
      parentId: grid,
      childrenIds: [],
      config: {
        size: "large",
        grid: [4, 2, 0, 0],
      },
    },
    {
      id: googleEmails,
      name: "GoogleEmails",
      parentId: grid,
      childrenIds: [],
      config: {
        grid: [3, 3, 4, 3],
        size: "medium",
      },
    },
    {
      id: time2,
      name: "Time",
      parentId: grid,
      config: {
        timeFormat: "hh:mm:ss",
        dateFormat: "dd/MM/yyyy",
        timeAlign: "center",
        dateAlign: "center",
        gap: "0",
        grid: [2, 2, 2, 2],
      },
      childrenIds: [],
    },
    {
      id: pomodoro,
      name: "Pomodoro",
      parentId: grid,
      config: {
        workDuration: 25,
        breakDuration: 5,
        grid: [2, 2, 0, 2],
        sound: "alarm-01",
      },
      childrenIds: [],
    },
    {
      id: app1,
      name: "App",
      parentId: grid,
      config: {
        image: "https://unideck.app/icon.svg",
        address: "https://unideck.app",
        name: "UniDeck",
        grid: [1, 1, 8, 3],
      },
      childrenIds: [],
    },
    {
      id: app2,
      name: "App",
      parentId: grid,
      config: {
        image: "https://ainurhq.cloud/favicon.ico",
        address: "https://ainurhq.cloud",
        name: "Ainur",
        grid: [1, 1, 9, 3],
      },
      childrenIds: [],
    },
    {
      id: notes,
      name: "Notes",
      parentId: grid,
      config: {
        color: "linear-gradient(to top left,#ee0979,#ff6a00)",
        size: "small",
        grid: [2, 2, 10, 0],
      },
      childrenIds: [],
    },
    {
      id: weather,
      name: "Weather",
      parentId: grid,
      config: {
        units: "metric",
        size: "medium",
        grid: [2, 1, 10, 4],
      },
      childrenIds: [],
    },
    {
      id: counter,
      name: "Counter",
      parentId: grid,
      config: {
        color: "linear-gradient(to top left,#f953c6,#b91d73)",
        size: "small",
        grid: [2, 1, 10, 5],
      },
      childrenIds: [],
    },
  ]);
};
